import api from "../../api/cofocusAPI";

const BadgeAPI = {
  async getAllUserBadges(UID) {
    if (!UID) {
      throw new Error("Required data not provided for request.");
    }
    return await api.getResponseData({
      url: `api/badges/${UID}`,
      method: "get",
      withCredentials: true,
    });
  },

  async getUserUnawardedBadges(UID) {
    if (!UID) {
      throw new Error("Required data not provided for request.");
    }
    return await api.getResponseData({
      url: `api/badges/${UID}/unawarded`,
      method: "get",
      withCredentials: true,
    });
  },

  async confirmGotBadge(UID, badgeNr) {
    if (!UID || (!badgeNr && badgeNr !== 0)) {
      throw new Error("Required data not provided for request.");
    }
    return api.getResponseData({
      url: `api/badges/${UID}/confirmGotBadge`,
      method: "post",
      data: { UID, badgeNr },
      withCredentials: true,
    });
  },
};

export default BadgeAPI;
